import type { Session } from '@supabase/supabase-js';
import { z } from 'zod';

import { apiFetch } from '@/lib/api';

// Client contract for GET /api/v1/admin/lookup?q=... (support lookup).

const BookingHitSchema = z.object({
  id: z.string(),
  operatorId: z.string(),
  operatorSlug: z.string(),
  state: z.string(),
  paymentProcessor: z.string().nullable(),
  paymentState: z.string().nullable(),
  paymentIntentId: z.string().nullable(),
  refundId: z.string().nullable(),
  createdAt: z.string(),
  customerName: z.string().nullable(),
  customerEmail: z.string().nullable(),
});

const OperatorHitSchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  hostedPageEnabled: z.boolean(),
  createdAt: z.string(),
});

const CustomerHitSchema = z.object({
  id: z.string(),
  operatorId: z.string(),
  operatorSlug: z.string(),
  name: z.string(),
  email: z.string().nullable(),
  phone: z.string(),
  createdAt: z.string(),
});

export const LookupResultSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('booking'), booking: BookingHitSchema }),
  z.object({ kind: z.literal('operator'), operator: OperatorHitSchema }),
  z.object({ kind: z.literal('customer'), customers: z.array(CustomerHitSchema) }),
  z.object({ kind: z.literal('none') }),
]);

export type LookupResult = z.infer<typeof LookupResultSchema>;

export const fetchLookup = (
  session: Session,
  query: string,
  signal?: AbortSignal,
): Promise<LookupResult> =>
  apiFetch(`/api/v1/admin/lookup?q=${encodeURIComponent(query)}`, {
    session,
    schema: LookupResultSchema,
    ...(signal ? { signal } : {}),
  });

const ResendResponseSchema = z.object({ ok: z.literal(true) });

export const resendConfirmation = (session: Session, bookingId: string): Promise<{ ok: true }> =>
  apiFetch('/api/v1/admin/bookings/resend-confirmation', {
    session,
    method: 'POST',
    body: { bookingId },
    schema: ResendResponseSchema,
  });
